import React from "react";

export const content = (
    <div>
        Help goes here
    </div>
);


// WEBPACK FOOTER //
// ./src/routes/Help/content.js